module.exports = __webpack_public_path__ + "static/media/R-150XLHD_CrossSection.94853fcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/en/R-150XLHD_CrossSection.png
// module id = 475
// module chunks = 0